"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearCachedCalculation = exports.getAsyncCachedCalculation = exports.getCachedCalculation = void 0;
const cache = {};
function getCachedCalculation(cacheKey, time, callback) {
    cacheKey = _getGeneratedCacheKey(cacheKey, time);
    if (cache.hasOwnProperty(cacheKey)) {
        return cache[cacheKey];
    }
    cache[cacheKey] = callback();
    return cache[cacheKey];
}
exports.getCachedCalculation = getCachedCalculation;
function getAsyncCachedCalculation(cacheKey, time, callback) {
    return __awaiter(this, void 0, void 0, function* () {
        cacheKey = _getGeneratedCacheKey(cacheKey, time);
        if (cache.hasOwnProperty(cacheKey)) {
            return cache[cacheKey];
        }
        cache[cacheKey] = yield callback();
        return cache[cacheKey];
    });
}
exports.getAsyncCachedCalculation = getAsyncCachedCalculation;
function clearCachedCalculation(cacheKey, time) {
    cacheKey = _getGeneratedCacheKey(cacheKey, time);
    if (cache.hasOwnProperty(cacheKey)) {
        delete cache[cacheKey];
    }
}
exports.clearCachedCalculation = clearCachedCalculation;
function _getGeneratedCacheKey(cacheKey, time) {
    return `${cacheKey}_${time};`;
}
